/* =========================
   MOVE PRODUCT SWATCHES
   BELOW PRICE
   ========================= */

function moveProductSwatches() {
  document.querySelectorAll('.card-product').forEach((card) => {
    const swatches = card.querySelector('variant-king-combined-listing');
    const price = card.querySelector('.card-information .price');

    if (swatches && price && swatches.previousElementSibling !== price) {
      price.insertAdjacentElement('afterend', swatches);
    }
  });
}

/* Run when page loads */
document.addEventListener('DOMContentLoaded', moveProductSwatches);

/* Re-run when products/swatches are dynamically loaded */
const swatchObserver = new MutationObserver(() => {
  moveProductSwatches();
});

swatchObserver.observe(document.body, {
  childList: true,
  subtree: true
});

/* KLAVIYO BACK IN STOCK - SYNC WITH SELECTED PDP VARIANT */
document.addEventListener('DOMContentLoaded', function () {

  function syncKlaviyoBackInStock() {

    /* Target the MAIN PDP Add to Cart button only */
    const addToCartButton =
      document.querySelector('product-info button[id^="ProductSubmitButton-"][id$="__main"]') ||
      document.querySelector('product-info .product-form__submit[name="add"]');

    const klaviyoButton = document.querySelector('.klaviyo-bis-trigger');

    if (!addToCartButton || !klaviyoButton) return;

    const buttonText = addToCartButton.textContent
      .trim()
      .toLowerCase();

    /*
      Do NOT use disabled or aria-disabled.
      Those can be temporary loading states during Add to Cart.
    */
    const isSoldOut =
      buttonText.includes('sold out') ||
      buttonText.includes('unavailable');

    if (isSoldOut) {
      klaviyoButton.style.setProperty('display', 'flex', 'important');
    } else {
      klaviyoButton.style.setProperty('display', 'none', 'important');
    }
  }

  /* Initial load */
  setTimeout(syncKlaviyoBackInStock, 300);

  /* Variant changes */
  document.addEventListener('change', function () {
    setTimeout(syncKlaviyoBackInStock, 200);
  });

  /*
    Klaviyo/theme may replace elements after variant updates,
    but don't watch disabled / aria-disabled / class changes.
  */
  const observer = new MutationObserver(function () {
    syncKlaviyoBackInStock();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});